<template>
  <div class="pdt-20px full-width column is-12">
    <div class="card">
      <header class="header-card">
        <p>
          {{$t('factorFacture.titre')}}
        </p>
      </header>
      <div class="card-content">
        <div class="columns is-marginless is-paddingless is-multiline">
          <b-field :label="$t('factorFacture.factor')" class="column is-4">
            <b-autocomplete
              :value="nomFactor"
              :open-on-focus="openOnFocus"
              :data="dataFactors"
              field="nomWithAdresseAndCompteComptable"
              @select="selectFactor"
              @input="getFactor"
              :loading="isFetching"
              :placeholder="$t('factorFacture.searchFactor')">
              <template slot-scope="props">
                {{ props.option.nomWithAdresseAndCompteComptable }}
              </template>
              <template slot="empty">
                <div v-if="!isFetching">
                  {{$t('general.autocomplete.noRslt')}}
                </div>
              </template>
            </b-autocomplete>
          </b-field>
          <b-field :label="$t('factorFacture.transmis')"
            class="column is-1" custom-class="mgb-14px">
            <qd-checkbox v-model="factureDetail.factorTransmis">
            </qd-checkbox>
          </b-field>
          <b-field :label="$t('factorFacture.dateTransmission')" class="column is-narrow">
            <b-datepicker show-week-number
                            v-model="factureDetail.factorDateTransmission"
                            icon="calendar-today"
                            nearby-selectable-month-days
                            editable>
            </b-datepicker>
          </b-field>
          <div class="column is-12" v-if="factureDetail.tiersFactorId">
             <b-field :label="$t('editionFournisseur.commentaire.commentairesFactor')">
               <qd-text-editor v-model="factureDetail.commentaireFactor"/>
             </b-field>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import { TIERS_TYPE_FOURNISSEUR, TIERS_SOUS_TYPE_FACTOR } from '@/configuration/tiers/tiersConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import messageErreur from '@/services/general/messageErreur';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    factureDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nomFactor: null,
      isFetching: false,
      dataFactors: [],
      openOnFocus: false,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
  },
  methods: {
    getFormattageFactor(factor) {
      let libelle = factor.nomCommercial;
      const adresse = factor.adresse ? factor.adresse : factor.adressePostale;
      if (adressFullStringGetter(adresse, false) !== '') {
        libelle += ' - ' + adressFullStringGetter(adresse, false);
      }
      if (factor.compteComptable) {
        libelle += ' - ' + factor.compteComptable;
      }
      return libelle;
    },
    getFactor: debounce(async function factorsData(text) {
      if (text === this.nomFactor) return;
      try {
        this.nomFactor = text;
        this.isFetching = true;
        this.factureDetail.tiersFactorId = null;
        this.factureDetail.commentaireFactor = null;
        const dataFactors = (await getAll({
          query: {
            type: TIERS_TYPE_FOURNISSEUR,
            auto: text,
            sousType: [TIERS_SOUS_TYPE_FACTOR],
            societeId: this.societeActiveId,
            archive: false,
          },
        })).data.result.items;
        dataFactors.map((factor) => {
          factor
            .nomWithAdresseAndCompteComptable = this.getFormattageFactor(factor);
          return factor;
        });
        this.dataFactors = dataFactors.filter((factor) => {
          return this.factureDetail.tiersFactorId !== factor.id;
        });
        this.isFetching = false;
      } catch (e) {
        messageErreur(this.$i18n);
        this.isFetching = false;
        throw e;
      }
    }, 500),
    selectFactor(data) {
      if (data) {
        this.factureDetail.tiersFactorId = cloneDeep(data.id);
        this.factureDetail.commentaireFactor = cloneDeep(data.commentaireFactor);
        this.nomFactor = cloneDeep(data.nomWithAdresseAndCompteComptable);
      }
    },
  },
  mounted() {
    this.nomFactor = this.factureDetail.tiersFactorId
      ? this.getFormattageFactor(this.factureDetail.tiersFactor) : null;
  },
};
</script>
